import type { PermissionAction, PermissionArea } from '@/types';

/** メニュー表示とログイン後の行き先を、同じ実効権限で判定する。 */
export function canAccessNavigationItem(
  item: {
    permission?: PermissionArea;
    permissionActions?: PermissionAction[];
    permissionAnyArea?: PermissionArea[];
    permissionAllAreas?: PermissionArea[];
  },
  can: (area: PermissionArea, action: PermissionAction) => boolean,
): boolean {
  if (item.permissionAllAreas?.some((area) => !can(area, 'read'))) return false;
  if (item.permissionAnyArea?.length) {
    return item.permissionAnyArea.some((area) => can(area, 'read'));
  }
  const area = item.permission;
  if (!area) return true;
  return (item.permissionActions ?? ['read']).some((action) => can(area, action));
}
